import { ReactElement } from 'react';

import { Loader } from '@neo.tax/shared';

import { SredPayrollExpenseLayout } from '../../organisms';
import { useSredPayrollExpensesRedirect } from './hooks';

export const SredPayrollExpenses = (): ReactElement => (
  <Loader useRedirect={useSredPayrollExpensesRedirect}>
    <SredPayrollExpenseLayout />
  </Loader>
);
